<div class="assignee-filter-container">
	<div class="filter-options">
		@if ((filterOptions$ | async)?.length) {
			<assignee-options-list
				[options]="filterOptions$ | async"
				[disableTeamsSelection]="true"
				[showSelected]="true"
				(selectionChange)="selectOption($event)"
			/>
		} @else {
			<div class="no-data p-l-sm m-t-sxs m-b-sxs">
				{{ 'no_options_available' | translate }}
			</div>
		}
	</div>
</div>
